/**
 * Marketing CTA Component
 * Handles close button functionality with cookie persistence
 */

function fnMarketingCta() {
	const marketingCta = document.querySelector('.marketing-cta');
	if (!marketingCta) return;
	
	const closeButton = marketingCta ? marketingCta.querySelector('.close-button') : null;
	
	// Function to set cookie
	function setCookie(name, value, days) {
		const expires = new Date();
		expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
		document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
	}
	
	if (closeButton && marketingCta) {
		closeButton.addEventListener('click', function() {
			marketingCta.classList.add('hide');
			// Set cookie to remember user's choice for 30 days
			setCookie('marketing_cta_closed', 'true', 30);
		});
	}
}